import React, {Fragment, useState} from "react";
import '../assets/cssnew/panel.css'
import Box from '@mui/material/Box';

import Header_Panel_Mobile_Pc from "../components/Header_Panel_Mobile_Pc";
import '../assets/css/aside.css'

import 'react-toastify/dist/ReactToastify.css';
import {useLocation} from "react-router-dom";

import Menue_Panel from "../components/Header/Panel_layouts/Menue_Panel";


const Master_Front = (props) => {
    const location = useLocation();


    const[show_menu_panel,setshow_menu_panel] = useState('hide');

    const [mobileOpen, setMobileOpen] = useState(false);



    const handleDrawerToggle = () => {
 setMobileOpen(!mobileOpen);
        ///setMobileOpen(true);
    };




    return (
        <Fragment>

<style jsx>{`
body{ background:  #F2F2F3 !important; }

`}
</style>






            <Box sx={{"display":"flex","flexDirection":"row"}}>

                {/*  This code must be before the BOX element.  */}
                <Menue_Panel status_authentication={props.status_authentication} type_user_panel={props.type_user_panel}  mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle}    menu_show={show_menu_panel} wallet_balance={props.wallet_balance} first_name_profile={props.first_name_profile} last_name_profile={props.last_name_profile} first_name_last_name={props.first_name_last_name}  profile_src={props.profile_src} />


                <Box className={"box_main_page_panel"} component="main" >
                    <section className="panel_main">
                        <Header_Panel_Mobile_Pc status_authentication={props.status_authentication} type_user_panel={props.type_user_panel}  handle_Open_menu={handleDrawerToggle} wallet_balance={props.wallet_balance} first_name_profile={props.first_name_profile} last_name_profile={props.last_name_profile} profile_src={props.profile_src}  />
                        {props.children}
                    </section>
                </Box>



            </Box>



        </Fragment>
    );
}

export default Master_Front;